import React from "react";
import { TextField, Button, createMuiTheme } from "@material-ui/core";
import { Formik } from "formik";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import jalaali from "jalaali-js";
import { actions } from "../CrudAndRedux/ProfileRedux";
import { useDispatch, useSelector } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { create } from "jss";
import { jssPreset, StylesProvider } from "@material-ui/styles";
import convertPersianToEnglishNumber from "../../../utils/convert-persian-to-english-number";
import { toast } from "react-toastify";
import { getUserTravelInfo } from "../CrudAndRedux/ProfileCrud";
import moment from "moment-jalaali";
const jss = create({
  plugins: [...jssPreset().plugins],
});

const TravelsSearchCard = (props) => {
  const [selectedDay, setSelectedDay] = React.useState(null);
  const [desDay, setDesDay] = React.useState(null);

  const { state } = useSelector((state) => ({
    state: state.profile,
  }));
  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));
  const dispatch = useDispatch();

  const renderSrcCustomInput = ({ ref }) => {
    return (
      <input
        readOnly
        placeholder="تاریخ"
        value={
          selectedDay
            ? `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`
            : ""
        }
        ref={ref}
        style={{
          textAlign: "right",
          padding: "1.9rem 1rem",
          fontSize: "1rem",
          border: "1px solid #d9d9d9",
          width: "100%",
          borderRadius: "13px",
          color: "currentColor",
          height: "48px",
          outline: "none",
          backgroundColor: "white",
        }}
        className="my-custom-input-class" // a styling class
      />
    );
  };

  // const renderDesCustomInput = ({ ref }) => {
  //   return (
  //     <input
  //       readOnly
  //       placeholder="تا تاریخ(خرید)"
  //       value={desDay ? `${desDay.year}/${desDay.month}/${desDay.day}` : ""}
  //       ref={ref}
  //       style={{
  //         textAlign: "right",
  //         padding: "1.9rem 1rem",
  //         fontSize: "1rem",
  //         border: "1px solid #d9d9d9",
  //         width: "100%",
  //         borderRadius: "13px",
  //         color: "currentColor",
  //         height: "48px",
  //         outline: "none",
  //         backgroundColor: "white",
  //       }}
  //       className="my-custom-input-class" // a styling class
  //     />
  //   );
  // };

  return (
    <div
      className="row flex-column bg-white   pt-5 mx-auto mt-3 text-right container"
      style={{
        border: "1px solid #d9d9d9",
        borderRadius: 13,
        boxShadow: " 0px 0px 10px #d9d9d9",
      }}
    >
      <h2 className="my-4">
        <b>جست و جوی سفر</b>
      </h2>

      <Formik
        enableReinitialize
        initialValues={{}}
        onSubmit={(values) => {
          console.log("sssss")
          if (selectedDay) {
            var miladi = moment(`${selectedDay?.year}/${selectedDay?.month}/${selectedDay?.day}`, "jYYYY/jM/jD").format("YYYY-MM-DD")
          }
          if (desDay) {
            var miladi1 = moment(`${desDay?.year} /${desDay?.month} / ${desDay?.day}`, "jYYYY/jM/jD").format("YYYY-MM-DD")
          }
          const params = {
            startDate: miladi,
            endDate: miladi1,
            travelTicketId: values.id,
          }
          getUserTravelInfo(authState.user.token, params)
            .then((res) => {
              dispatch(actions.getUserHistory(res.data));
              dispatch(actions.setMockedData(res.data));
            })
            .catch(() => {
              toast("مشکلی در ارتباط با سرور بوجود آمد");
            });
        }}
      >
        {({ handleSubmit, setFieldValue }) => {
          return (
            <StylesProvider jss={jss}>
              <div className="d-flex flex-wrap my-5">
                <div className="col-12 col-md-3 my-1 p-0">
                  <div className="p-4">
                    {" "}
                    <TextField
                      className="ticket-search-imputs"
                      variant="outlined"
                      placeholder="شماره سفارش"
                      onChange={(e) => setFieldValue("id", e.target.value)}
                      type="number"
                      style={{ borderRadius: "13px" }}
                    />
                  </div>
                </div>
                <div className="col-6 col-md-3 my-1 p-0">
                  <div className="p-4">
                    {" "}
                    <DatePicker
                      value={selectedDay}
                      calendarPopperPosition="bottom"
                      onChange={setSelectedDay}
                      name="departureDate"
                      shouldHighlightWeekends
                      renderInput={renderSrcCustomInput}
                      className="p-1"
                      // minimumDate={utils("fa").getToday()}
                      style={{ height: "45px", width: "100%" }}
                      locale="fa"

                    />
                  </div>
                </div>
                <div className="col-6 col-md-3 my-1 p-0">
                  {/* <div className="p-4">
                    <DatePicker
                      value={desDay}
                      calendarPopperPosition="bottom"
                      onChange={setDesDay}
                      name="departureDate"
                      className="p-1"
                      shouldHighlightWeekends
                      renderInput={renderDesCustomInput}
                      // minimumDate={utils("fa").getToday()}
                      style={{ height: "45px", width: "100%" }}
                      locale="fa"
                    />
                  </div> */}
                </div>
                <div
                  className="col-12 col-md-3 my-1 d-flex p-4"
                  style={{ justifyContent: "flex-end" }}
                >
                  <Button
                    className="ticket-search-btn  text-white "
                    style={{
                      backgroundColor: "#6dd06d",
                      borderRadius: 13,
                      height: "4rem",
                    }}
                    onClick={() => handleSubmit()}
                  >
                    <h5 className="my-auto text-white">
                      <b>جست و جو</b>
                    </h5>
                  </Button>
                </div>
              </div>
            </StylesProvider>
          );
        }}
      </Formik>
    </div>
  );
};

export default TravelsSearchCard;
